/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { isIOS } from "react-device-detect";

export interface IPricingDatumProps {
    title: string;
    currencySymbol: string;
    price: string;
    color?: string;
    periodicity: string;
    image?: string;
    availableFeatures?: string[];
    nonAvailableFeatures?: string[];
    buyNowButtonLabel?: string;
    buyNowLink?: string;
    isFeatured?: string;
}

export interface IPricingProps {
    pricingSectionId?: string;
    pricingLabel?: string;
    pricingDescription?: string;
    pricingData?: IPricingDatumProps[];
}

const DEFAULT_COLORS = ["#07d5c0", "#65c600", "#ff901c", "#ff0071"];

export const Pricing = ({
    pricingSectionId,
    pricingLabel,
    pricingDescription,
    pricingData
}: IPricingProps) => {
    const _renderPricing = () => {
        let _aos_props: any = {};
        if (!isIOS) {
            _aos_props = {
                "data-aos": "zoom-in",
                "data-aos-delay": "100"
            };
        }
        let _comp: any = [];
        if (pricingData) {
            pricingData?.forEach((price, index) => {
                _comp.push(
                    <div
                        key={`pricing-table-${index}`}
                        className="col-lg-3 col-md-6"
                        {..._aos_props}
                    >
                        <div className="box">
                            {price?.isFeatured && (
                                <span className="featured">
                                    {price?.isFeatured}
                                </span>
                            )}
                            {price?.title && (
                                <h3
                                    style={{
                                        color:
                                            price?.color ??
                                            DEFAULT_COLORS[
                                                index % DEFAULT_COLORS.length
                                            ]
                                    }}
                                >
                                    {price.title}
                                </h3>
                            )}
                            <div className={"price"}>
                                <sup>{price?.currencySymbol}</sup>
                                {price?.price}
                                <span>{price?.periodicity ?? " / mo"}</span>
                            </div>
                            {price?.image && (
                                <img
                                    src={price?.image}
                                    className="img-fluid"
                                    alt=""
                                />
                            )}
                            <ul>
                                {price?.availableFeatures?.map((af, index) => (
                                    <li key={`pricing-af-${index}`}>{af}</li>
                                ))}
                                {price?.nonAvailableFeatures?.map(
                                    (naf, index) => (
                                        <li
                                            key={`pricing-naf-${index}`}
                                            className="na"
                                        >
                                            {naf}
                                        </li>
                                    )
                                )}
                            </ul>
                            <a
                                href={price?.buyNowLink ?? "/"}
                                className="btn-buy"
                            >
                                {price?.buyNowButtonLabel ?? "Buy Now"}
                            </a>
                        </div>
                    </div>
                );
            });
        }
        return _comp;
    };
    let _aos_props: any = {};
    if (!isIOS) {
        _aos_props = {
            "data-aos": "fade-up"
        };
    }
    let _aos_pricing_props: any = {};
    if (!isIOS) {
        _aos_pricing_props = {
            "data-aos": "fade-left"
        };
    }
    return (
        <>
            <section id={pricingSectionId} className="pricing">
                <div className="container" {..._aos_props}>
                    <header className="section-header">
                        <h2>{pricingLabel}</h2>
                        <p>{pricingDescription}</p>
                    </header>
                    <div className="row gy-4" {..._aos_pricing_props}>
                        {_renderPricing()}
                    </div>
                </div>
            </section>
        </>
    );
};

Pricing.defaultProps = {
    pricingSectionId: "pricing",
    pricingLabel: "Pricing",
    pricingDescription: "Check our Pricing"
};
